"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAutoHideControls = void 0;
var react_1 = __importDefault(require("react"));
var browser = __importStar(require("../utils/browser"));
var react_2 = require("@xstate/react");
var selectors_1 = require("../selectors");
var video_context_1 = require("../context/video-context");
var DELAY = 1250;
var useAutoHideControls = function () {
    var _a = react_1.default.useState(false), controlsHovered = _a[0], setControlsHovered = _a[1];
    var _b = react_1.default.useState(false), controlsHidden = _b[0], setControlsHidden = _b[1];
    var videoService = (0, video_context_1.useVideo)();
    var isFullscreen = (0, react_2.useSelector)(videoService, selectors_1.selectIsFullscreen);
    react_1.default.useEffect(function () {
        !isFullscreen && setControlsHidden(false);
        var hideControlsInFullscreen = setTimeout(function () {
            if (!browser.IS_IOS && !controlsHovered && isFullscreen)
                setControlsHidden(true);
        }, DELAY);
        return function () { return clearTimeout(hideControlsInFullscreen); };
    }, [isFullscreen, controlsHidden, controlsHovered]);
    return {
        controlsHidden: controlsHidden,
        setControlsHovered: setControlsHovered,
        setControlsHidden: setControlsHidden,
    };
};
exports.useAutoHideControls = useAutoHideControls;
